import axios from 'axios'
import store from '../store/index.js'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'https://ru.api-contact.site'
})

api.CancelToken = axios.CancelToken
api.isCancel = axios.isCancel

/*
* The interceptor here ensures that we check for the token in local storage every time an ajax request is made
*/
api.interceptors.request.use(
 (config) => {
   
   const token = store.state.user.token

   if (token) {
     console.log(config.headers)
    // config.headers.Authorization = `Bearer ${token}`
    // config.headers.common.Authorization = `Bearer ${token}`
    config.headers["Authorization"] = token
     // config.headers['x-access-tokens'] = token
   }

   return config
 },

 (error) => {
   return Promise.reject(error)
 }
)

export default api
